import { httpMethods } from '@services/httpClientService';

import { THREE_DS_ONE_PARAM_MD, THREE_DS_ONE_PARAM_PA_REQ, THREE_DS_ONE_PARAM_TERM_URL } from '../constants';

/**
 * This method creates hidden form and submits it.
 * @param submitUrl - url where form should be submitted
 * @param paReq - paReq 3DS1 request parameter
 * @param md - md 3DS1 request parameter
 * @param termUrl - termUrl 3DS1 request parameter
 */
export const createAndSubmitThreeDsAuthForm = (submitUrl: string, paReq: string, md: string, termUrl: string) => {
  const formElement = document.createElement('form');
  formElement.action = submitUrl;
  formElement.hidden = true;
  formElement.method = httpMethods.POST;
  formElement.appendChild(createInputElementWithValue(THREE_DS_ONE_PARAM_PA_REQ, paReq));
  formElement.appendChild(createInputElementWithValue(THREE_DS_ONE_PARAM_MD, md));
  formElement.appendChild(createInputElementWithValue(THREE_DS_ONE_PARAM_TERM_URL, termUrl));
  document.body.appendChild(formElement);
  formElement.submit();
};

/**
 * This method creates hidden input element with certain value
 * @param name - name of the hidden input
 * @param value - value of the hidden input
 */
const createInputElementWithValue = (name: string, value: string) => {
  const inputElement = document.createElement('input');
  inputElement.name = name;
  inputElement.value = value;
  inputElement.hidden = true;

  return inputElement;
};
